"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Name_1 = __importDefault(require("./styledComponents/Name"));

var Description_1 = __importDefault(require("./styledComponents/Description"));

var ImageWrapper_1 = __importDefault(require("./styledComponents/ImageWrapper"));

var AwardImage_1 = __importDefault(require("./styledComponents/AwardImage"));

var Translate_1 = __importStar(require("../../base/Translate/Translate"));

var Award_meta_1 = require("./Award.meta");

var mobx_1 = require("mobx");

var Award =
/** @class */
function (_super) {
  __extends(Award, _super);

  function Award(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Award_meta_1.AWARD_CATEGORY_KEY;
    _this.componentKey = Award_meta_1.AWARD_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(Award.prototype, "Image", {
    get: function get() {
      var photoSrc = this.props.photoSrc;
      var imageProps = this.props.imageProps;

      if (photoSrc) {
        if (imageProps) {
          imageProps.src = photoSrc;
        } else {
          imageProps = {
            src: photoSrc
          };
        }
      }

      return react_1.default.createElement(ImageWrapper_1.default, null, react_1.default.createElement(AwardImage_1.default, __assign({}, imageProps)));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Award.prototype, "Name", {
    get: function get() {
      var name = this.props.name;
      return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(name) && react_1.default.createElement(Name_1.default, null, react_1.default.createElement(Translate_1.default, null, name));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Award.prototype, "Description", {
    get: function get() {
      var _a = this.props,
          description = _a.description,
          textProps = _a.textProps;

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(description)) {
        var descriptionProps = __assign(__assign({}, textProps), {
          value: description
        });

        return react_1.default.createElement(Description_1.default, __assign({}, descriptionProps));
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Award.prototype, "nameFirst", {
    get: function get() {
      var layout = this.props.layout;
      return layout === 'name-first';
    },
    enumerable: true,
    configurable: true
  });

  Award.prototype.render = function () {
    var _this = this;

    var className = this.props.className;
    var groupLabel = 'Awards';

    if (this.translationContext) {
      groupLabel = this.translationContext.translate(groupLabel);
    }

    return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      _this.translationContext = translationContext;
      return null;
    }), react_1.default.createElement(Wrapper_1.default, {
      className: className,
      role: "group",
      "aria-label": groupLabel
    }, this.nameFirst && this.Name, this.Image, !this.nameFirst && this.Name, this.Description));
  };

  __decorate([mobx_1.computed], Award.prototype, "Image", null);

  __decorate([mobx_1.computed], Award.prototype, "Name", null);

  __decorate([mobx_1.computed], Award.prototype, "Description", null);

  __decorate([mobx_1.computed], Award.prototype, "nameFirst", null);

  Award = __decorate([mobx_react_1.observer], Award);
  return Award;
}(shared_1.ComponentBase);

exports.Award = Award;
exports.default = shared_1.InjectedStyledComponent(Award, Award_meta_1.AWARD_CATEGORY_KEY, Award_meta_1.AWARD_COMPONENT_KEY);